import { QP_EDIT_RESOURCE_ID } from '@/constants/queryParams';
import { useSearchParams } from '@/hooks/useSearchParams';
import { useListResourcesQuery } from '@/queries/resources.queries';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

export function useSectionParticipants() {
	const { t } = useTranslation();
	const params = useSearchParams();
	const editResourceId = params.get(QP_EDIT_RESOURCE_ID);
	const history = useHistory();
	const participantsQuery = useListResourcesQuery();

	function closeModal() {
		params.delete(QP_EDIT_RESOURCE_ID);
		history.replace({ search: params.toString() });
	}

	function openModal(id: string) {
		params.append(QP_EDIT_RESOURCE_ID, id);
		history.replace({ search: params.toString() });
	}

	return {
		participantsQuery,
		t,
		editResourceId,
		isModalOpen: !!editResourceId,
		closeModal,
		openModal,
	};
}
